export const WHY_CHOOSE = [
  { icon: "ShieldCheck", title: "Licensed Professional Counselors", text: "Every session is led by a fully licensed, experienced clinician." },
  { icon: "Brain", title: "Evidence-Based CBT", text: "Grounded in the most researched, effective form of psychotherapy." },
  { icon: "User", title: "Individual Therapy", text: "One-on-one care tailored precisely to your goals." },
  { icon: "HeartHandshake", title: "Couples Therapy", text: "Rebuild connection, communication, and trust." },
  { icon: "Users", title: "Family Therapy", text: "Support that strengthens the whole system, together." },
  { icon: "Baby", title: "Children & Teens", text: "Age-appropriate, engaging care for young minds." },
  { icon: "Video", title: "Telehealth Available", text: "Secure, HIPAA-compliant sessions from anywhere in CT." },
  { icon: "BadgeCheck", title: "Most Major Insurance", text: "We accept most major insurance plans." },
  { icon: "ClipboardList", title: "Personalised Treatment Plans", text: "A clear roadmap built around your life." },
  { icon: "Sparkles", title: "Practical Everyday Skills", text: "Tools you can use the very same week." },
];

export const WE_HELP = [
  "Stop Overthinking",
  "Reduce Anxiety",
  "Break Panic Cycles",
  "Improve Relationships",
  "Build Confidence",
  "Sleep Better",
  "Manage Depression",
  "Overcome Avoidance",
  "Handle Intrusive Thoughts",
  "Develop Healthy Habits",
  "Feel Like Yourself Again",
  "Manage Sleep Disorders",
  "Navigate Eating Disorders",
  "Trauma & Stress Adjustment",
  "Steady Bipolar Cycles",
  "Cope with Schizophrenia",
  "Substance & Addictive Disorders",
  "Neurodevelopmental & Behavioral Support",
  "Somatic & Health-Related Concerns",
];

export const CONDITIONS = [
  { name: "Anxiety", icon: "Wind", to: "/anxiety" },
  { name: "Depression", icon: "CloudRain", to: "/depression" },
  { name: "OCD", icon: "RefreshCw", to: "/ocd" },
  { name: "ADHD Planning & Assistance", icon: "ListChecks", to: "/adhd" },
  { name: "Trauma", icon: "ShieldAlert", to: "/trauma" },
  { name: "PTSD", icon: "HeartPulse", to: "/ptsd" },
  { name: "Panic Attacks", icon: "AlertCircle", to: "/panic" },
  { name: "Stress", icon: "Gauge", to: "/stress" },
  { name: "Relationship Issues", icon: "Heart", to: "/couples-counseling" },
  { name: "Life Transitions", icon: "Route", to: "/individual-therapy" },
  { name: "Self-Esteem", icon: "Star", to: "/individual-therapy" },
  { name: "Grief", icon: "Feather", to: "/individual-therapy" },
  { name: "Children & Teen Mental Health", icon: "Baby", to: "/children-and-teens" },
  { name: "Eating Disorders", icon: "Utensils", to: "/contact" },
  { name: "Bipolar Disorder", icon: "Waves", to: "/contact" },
  { name: "Schizophrenia", icon: "Brain", to: "/contact" },
  { name: "Autism / Autistic Life Needs", icon: "Puzzle", to: "/contact" },
  { name: "Neurodevelopmental & Behavioral Disorders", icon: "Network", to: "/contact" },
  { name: "IEP / 504 Planning & Assistance", icon: "GraduationCap", to: "/contact" },
];

export const CBT_SCENARIO = "A worked example — an unanswered text, and the spiral of an awkward social interaction.";

export const CBT_CYCLE = [
  { label: "Situation", icon: "MapPin", desc: "You text a friend asking if they want to hang out, but they don't respond for several hours." },
  { label: "Thought", icon: "Brain", desc: "\u201cThey\u2019re ignoring me. They probably don\u2019t like me anymore.\u201d" },
  { label: "Emotion", icon: "Heart", desc: "Sad, anxious, and rejected \u2014 about 80/100 in intensity." },
  { label: "Behaviour", icon: "Activity", desc: "You stop texting them, isolate in your room, and replay the situation in your head." },
  { label: "Result", icon: "Repeat", desc: "Your mood gets worse, and because you withdraw, you never discover that your friend was simply busy." },
];

export const HOW_CBT = [
  { label: "Thoughts", icon: "Brain", color: "teal" },
  { label: "Emotions", icon: "Heart", color: "softblue" },
  { label: "Behaviours", icon: "Zap", color: "navy" },
  { label: "Better Life", icon: "Sprout", color: "teal" },
];

export const PROCESS = [
  { step: "01", title: "Assessment", text: "We start by truly understanding you—your history, symptoms, strengths, and what a better life looks like to you." },
  { step: "02", title: "Personalised Goals", text: "Together we define clear, measurable goals so therapy always has direction and purpose." },
  { step: "03", title: "Treatment Plan", text: "You receive a structured, evidence-based roadmap tailored to your specific challenges." },
  { step: "04", title: "Skill Building", text: "We teach practical CBT techniques to reframe thoughts, regulate emotions, and change behaviours." },
  { step: "05", title: "Practice Between Sessions", text: "Small, doable exercises turn insight into lasting habit—where real change happens." },
  { step: "06", title: "Measure Progress", text: "We track improvement with validated assessments so you can see and feel your growth." },
  { step: "07", title: "Long-Term Success", text: "You leave therapy with a toolkit for life—resilient, confident, and self-reliant." },
];

export const TESTIMONIALS = [
  { quote: "For the first time, therapy gave me actual tools. Within a month my panic attacks went from daily to almost none.", name: "R.M.", detail: "Anxiety & Panic" },
  { quote: "I finally understand the loop I was stuck in. Beacon helped me climb out of the darkest depression of my life.", name: "J.T.", detail: "Depression" },
  { quote: "We were on the edge of separating. The skills we learned here genuinely saved our marriage.", name: "K. & D.", detail: "Couples Counseling" },
  { quote: "My teenage son actually looks forward to his sessions. His confidence at school has transformed.", name: "L.P.", detail: "Parent of Teen Client" },
  { quote: "Measurement-based care meant I could see my progress on paper. That kept me going on hard weeks.", name: "S.V.", detail: "OCD Treatment" },
];

export const INSURANCE = [
  "United Healthcare (Optum)",
  "Oscar (Optum)",
  "Anthem EAP – Expanded",
  "Blue Cross Blue Shield of Massachusetts",
  "Independence Blue Cross (Pennsylvania)",
  "Horizon Blue Cross Blue Shield (New Jersey)",
  "Carelon Behavioral Health",
  "Anthem Blue Cross Blue Shield (Connecticut)",
  "Aetna",
  "Cigna",
  "Anthem EAP – Standard",
  "United Healthcare Medicare Advantage (pending)",
];

export const FAQS = [
  { q: "Do you accept my insurance?", a: "We accept most major insurance plans, including Aetna, Anthem, Blue Cross Blue Shield, Cigna, and UnitedHealthcare. Contact us with your plan details and we\u2019ll verify your benefits before your first visit." },
  { q: "What is Cognitive Behavioral Therapy (CBT)?", a: "CBT is a structured, evidence-based form of therapy that helps you identify and change unhelpful thinking patterns and behaviours. Instead of years of open-ended talk, CBT gives you practical skills you can apply immediately." },
  { q: "Do you offer Telehealth?", a: "Yes. We offer secure, HIPAA-compliant video sessions to anyone located in Connecticut, with the same quality of care as in-person visits." },
  { q: "How long does therapy take?", a: "CBT is typically shorter-term than traditional talk therapy. Many clients notice meaningful change within 12\u201320 sessions, though your plan is always personalised to you." },
  { q: "Do you work with children and teens?", a: "Absolutely. We have specialists trained in child and adolescent mental health who use age-appropriate, engaging methods and involve families in the process." },
  { q: "What happens in the first session?", a: "Your first session is a relaxed, thorough assessment. We\u2019ll discuss what brought you in, your goals, and begin shaping a treatment plan together—no pressure, just a plan." },
  { q: "Is what I share confidential?", a: "Yes. Your privacy is protected by law (HIPAA). We only break confidentiality in rare situations involving imminent safety risks, as required by law." },
];
